import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { IOfferTitleProps, OfferTitle } from './index';
import { isCountrysideCardIntegrated } from '../../utils/countrysideCardIntegration';
export function mapStateToProps(state: IState): IOfferTitleProps {
  return {
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
    isCountrysideCardIntegrated: isCountrysideCardIntegrated(state),
    agent: state.offerData.agent,
    kp: state.offerData.kp,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferTitleContainer = connect<IOfferTitleProps, any, any>(mapStateToProps)(OfferTitle);
